import R from 'ramda'

const OVERLAY_DEFAULT_ACTION_TYPE = 'OVERLAY_IMAGE'
const OVERLAY_DISPLAY_TYPE = 'Send overlay'

const isOverlayFormAction = R.propEq('type', OVERLAY_DISPLAY_TYPE)

const getOverlayMediaId = R.pipe(
  R.filter(Boolean),
  R.ifElse(
    R.has('overlayMediaId'),
    R.pipe(R.prop('overlayMediaId'), R.head),
    R.always(undefined)
  )
)

const convertOverlayFormActionToWidgetAction = R.applySpec({
  type: R.propOr(OVERLAY_DEFAULT_ACTION_TYPE, 'overlayType'),
  message: R.prop('message'),
  overlayMediaId: getOverlayMediaId,
  isPromotedTweet: R.prop('isPromotedTweet')
})

export { isOverlayFormAction, convertOverlayFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/overlay.js